// Styles for OffersAccordionContainerEnhanced go here.
import styled from 'styled-components';

export const StyledOffersAccordionContainerEnhanced = styled.div``;
